export const L10N = {
  LABEL_INSTALLMENTS: { id: 'core.label.installments' },

  NOTIFICATION_ERROR_LINKAGE_PAY: { id: 'core.notification.error_linkage_pay' },
};
